<template>
  <div>
    <div class="container no-bottom">
      <h2 class="title">Recommended Lists</h2>
      <div class="carousel-top">
        <div id="recommended" class="articles carousel">
          <div class="article carousel__container mtop-15">
            <transition-group name="carousel" tag="span">
              <div
                v-for="item in items"
                @click="subitem(item)"
                :key="item.id"
                :id="item.id"
                class="carousel-item"
              >
                <div class="article--div">
                  <div class="article--item">
                    <figure class="article-img">
                      <img
                        class="image"
                        :src="item.imageUrl"
                        click="test(item.id)"
                        :alt="item.title"
                      />
                    </figure>
                    <div class="article--title">
                      <div>
                        <div>{{ item.title }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="as"></div>
                </div>
              </div>
            </transition-group>
          </div>
        </div>
        <button class="icon-carousel icon-prev" @click="prev">
          <font-awesome-icon color="white" icon="chevron-left" />
        </button>
        <button class="icon-carousel icon-next" @click="next">
          <font-awesome-icon color="white" icon="chevron-right" />
        </button>
      </div>
      <div class="carousel-bottom">
        <div
          v-if="child_carousel"
          id="subrecomended"
          class="container carousel"
        >
          <div class="article carousel__container">
            <div
              v-for="item in child"
              @click="subitem(item)"
              :key="item.id"
              class="carousel-subitem"
            >
              <div class="article--item">
                <figure class="article-img">
                  <img
                    class="image"
                    :src="item.imageUrl"
                    click="test(item.id)"
                    :alt="item.title"
                  />
                </figure>
                <div class="article--title">
                  <div>
                    <div>{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          v-if="child_carousel"
          class="icon-carousel icon-prev"
          @click="prevsubitem"
        >
          <font-awesome-icon color="white" icon="chevron-left" />
        </button>
        <button
          v-if="child_carousel"
          class="icon-carousel icon-next"
          @click="nextsubitem"
        >
          <font-awesome-icon color="white" icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    params: {
      page: 0,
      country: "USA",
      recommendationsListId: "",
    },
    // key: this.title,
    items: [],
    child: [],
    child_carousel: false,
    totalPages: 0,
    select: "",
  }),
  created() {
    this.getItems();
  },
  computed: mapState(["user"]),
  methods: {
    goToRecommended() {
      this.unselect();
    },
    subitem(item) {
      if (this.select == item.id) {
        this.unselect();
        return;
      }
      if (item.children && item.children.length) {
        this.scrollToFist(item);
        this.select = item.id;
        this.child_carousel = true;
        this.child = item.children;

        let selected = document.getElementById(item.id);
        selected.firstChild.className = "item-active";
        selected.firstChild.lastChild.className = "horizontal-line-white";
      } else this.getRecommended(item);
    },
    unselect() {
      this.select = "";
      this.child_carousel = false;
      let activos = document.getElementsByClassName("item-active");
      activos.forEach((element) => {
        element.classList.remove("item-active");
        element.lastChild.classList.remove("horizontal-line-white");
      });
    },
    getItems() {
      this.$Parse.Cloud.run("getRecommendationLists")
        .then((res) => {
          this.items = res.map(function (obj) {
            return obj;
          });
          this.totalPages = res.totalPages;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRecommended(item) {
      const searchRegExp = /\s/g;
      const replaceWith = "-";
      let slug = item.title.replace(searchRegExp, replaceWith);

      this.$store.dispatch("FETCH_RECOMMENDED", item.id);
      this.$router.push(`/recommended/${item.id}/${slug}`);
    },
    scrollToFist(item) {
      // let a = document.getElementById("trailers").scrollLeft;
      // a += 600;
      document
        .getElementById("recommended")
        .scroll({ left: 0, behavior: "smooth" });

      let last = "";
      while (last.id != item.id) {
        last = this.items.pop();
        this.items.splice(0, 0, last);
      }
    },
    prev() {
      this.unselect();
      let last = this.items.pop();
      setTimeout(() => {
        this.items.splice(0, 0, last);
      }, 200);
    },
    next() {
      this.unselect();
      let first = this.items.shift();
      setTimeout(() => {
        this.items.push(first);
      }, 200);
    },
    prevsubitem() {
      let a = document.getElementById("subrecomended").scrollLeft;
      a -= 600;
      document
        .getElementById("subrecomended")
        .scroll({ left: a, behavior: "smooth" });
    },
    nextsubitem() {
      let a = document.getElementById("subrecomended").scrollLeft;
      a += 600;
      document
        .getElementById("subrecomended")
        .scroll({ left: a, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.recommended-area {
  display: flex;
  justify-content: space-evenly;
  column-gap: 20px;
  row-gap: 20px;
  flex-wrap: wrap;
}
.recommended-item {
  cursor: pointer;
  width: 190px;
}
.recommended-item-img {
  display: flex;
  justify-content: center;
}
.recommended-item-img > figure > img:hover {
  opacity: 0.7;
}
.recommended-item-img > figure > img:active {
  opacity: 0.7;
  width: 99%;
}
.recommended-item-img > figure {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 80%;
}

.slider {
  border: 1px solid #707070;
  background-color: rgba(28, 37, 49, 0.65);
  padding: 10px;
  border-radius: 10px;
  height: 20px;
  width: 20px;
}
.slider::after {
  font-size: 16px !important;
}

.articles {
  margin-top: 30px;
  border-radius: 10px;
}
.no-bottom {
  padding-bottom: 0;
  margin-bottom: 0;
}
.mtop-15 {
  margin-top: 15px;
}
h2 {
  font-weight: 400;
  border-bottom: 1px solid #738092;
}
.article {
  padding: 0 10px;
}

.article-item {
  margin: 0;
  position: relative;
}

.article-img {
  margin: 0;
}
.image {
  vertical-align: top;
  border-radius: 10px;
  width: 200px;
  height: 149px;
  object-fit: cover;
  cursor: pointer;
}
.article--title {
  width: 100%;
  position: absolute;
  top: 70%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  height: 30%;
  border-radius: 0px 0px 10px 10px;
}
.article--title > div {
  display: flex;
  height: 100%;
  white-space: normal;
  font-size: 0.85rem;
  padding: 0;
  padding-left: 10px;
  margin: 0;
  align-items: center;
}

.title {
  align-self: center;
  white-space: nowrap;
  font-size: 1.2em;
}
/* CAROUSEL */
.carousel-top,
.carousel-bottom {
  position: relative;
}
.carousel {
  overflow: scroll;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
}

.carousel__container:hover .carousel-item:hover {
  -webkit-transform: scale(1.01);
  transform: scale(1.01);
  opacity: 1;
}

.carousel-item {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
  height: 222px;
}

.carousel-subitem {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-carousel {
  /* background: rgba(0, 0, 0, 0);
  border: 0px solid #9e9e9e;
  padding: 5px;*/
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  top: 70px;
  height: 40px;
  width: 40px;
  border: 1px solid #707070;
  background-color: rgba(28, 37, 49, 0.65);
  padding: 10px;
  border-radius: 10px;
  color: rgba(252, 252, 252, 0);
}
.icon-carousel:hover {
}

.icon-prev {
  left: 0px;
}

.icon-next {
  right: 0px;
}

.item-active {
  border: 2px solid white;
  border-radius: 20px;
}
.article--div {
  position: relative;
}
.horizontal-line-white {
  overflow-x: visible;
  visibility: visible;
  border-left: 2px solid white;
  height: 80px;
  position: absolute;
  left: 50%;
  top: 153px;
  width: 10px;
  z-index: 999999;
}
.article--item {
  position: relative;
  border-radius: 20px;
}

/* .carousel-enter-active,
.carousel-leave-active {
  transition: all 1s;
}
.carousel-enter, .carousel-leave-to  {
  opacity: 0;
  transform: translateX(-200px);
  transition-duration: 200;
} */

.carousel-enter-active {
  animation: carousel 0.5s;
}
.carousel-leave-active {
  animation: carousel 0.5s reverse;
}

@keyframes carousel {
  0% {
    opacity: 0;
    left: -100%;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}

@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .linea {
    font-size: 18px;
  }
  h3.linea:before {
    width: 75%;
    left: 20%;
  }
  .image {
    border-radius: 15px;
    width: 244px;
    height: 182px;
  }
  .articles {
    padding: 20px 20px 0 20px;
  }
  .article--title {
    width: 315px;
  }
  .carousel-item {
    height: 230px;
  }
  .horizontal-line-white {
    top: 155px;
  }
  .image {
    width: 200px;
    height: 150px;
  }
  .article--title {
    width: 100%;
    position: absolute;
    top: 70%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    height: 30%;
    border-radius: 0px 0px 15px 15px;
  }
  .article--title > p {
    white-space: nowrap;
    overflow-y: hidden;
    text-overflow: ellipsis;
  }
}

@media (max-width: 600px) {
  .image {
    border-radius: 15px;
    width: 244px;
    height: 182px;
  }
  h3.linea:before {
    width: 50%;
    left: 50%;
  }
  .articles {
    padding: 10px;
  }

  .article--title {
    width: 275px;
  }

  .carousel-item {
    height: 180px;
  }
  .horizontal-line-white {
    top: 125px;
  }
  .image {
    width: 169px;
    height: 120px;
  }
  .article--title {
    width: 100%;
    position: absolute;
    top: 70%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    height: 30%;
    border-radius: 0px 0px 15px 15px;
  }
  .article--title > p {
    white-space: nowrap;
    overflow-y: hidden;
    text-overflow: ellipsis;
  }
}
</style>